import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Home,
  FileText,
  CreditCard,
  LogOut,
  Upload,
  PoundSterling,
  User,
  FileAudio,
} from 'lucide-react';
import AddCredit from './AddCredit';

const Navbar: React.FC = () => {
  const { isAuthenticated, logout, balance } = useAuth();
  const navigate = useNavigate();
  const [showAddCredit, setShowAddCredit] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const toggleAddCredit = () => {
    setShowAddCredit(!showAddCredit);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowAddCredit(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="bg-teal-600 text-white p-4 relative z-20">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-bold flex items-center">
          <FileAudio className="w-8 h-8 mr-2 text-teal-200" />
          Voice2Text Admin
        </Link>
        <div className="flex items-center space-x-4">
          <Link to="/dashboard" className="hover:text-blue-200">
            <Home className="inline-block mr-1" /> Dashboard
          </Link>
          <Link to="/jobs" className="hover:text-blue-200">
            <FileText className="inline-block mr-1" /> Job History
          </Link>
          <Link to="/upload" className="hover:text-blue-200">
            <Upload className="inline-block mr-1" /> Upload File
          </Link>
          <Link to="/account" className="hover:text-blue-200">
            <User className="inline-block mr-1" /> Account
          </Link>
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={toggleAddCredit}
              className="hover:text-blue-200 flex items-center"
            >
              <CreditCard className="inline-block mr-1" /> Add Credit
            </button>
            {showAddCredit && (
              <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl overflow-hidden z-30 transition-all duration-300 ease-in-out transform origin-top-right">
                <AddCredit onClose={() => setShowAddCredit(false)} />
              </div>
            )}
          </div>
          <span className="bg-teal-700 px-3 py-1 rounded-full flex items-center">
            <PoundSterling className="mr-1" size={16} />
            {balance.toFixed(2)}
          </span>
          <button onClick={handleLogout} className="hover:text-blue-200">
            <LogOut className="inline-block mr-1" /> Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;